import { useState } from 'react';
import { ETAPAS, ETAPA_MAP } from '../../lib/constants';
import { DemandaCard } from './DemandaCard';
import { api } from '../../api/client';
import { useAuth } from '../../contexts/AuthContext';

export function KanbanBoard({ demandas, onChange }) {
  const { user } = useAuth();
  const podeMover = user?.perfil === 'comunicacao' || user?.perfil === 'admin';
  // Mostra coluna "Cancelada" só se houver demandas canceladas no resultado
  // (ou seja, quando o usuário marcou "Mostrar canceladas").
  const temCanceladas = demandas.some((d) => d.etapa === 'cancelada');
  const colunas = ETAPAS.filter((e) => e.key !== 'cancelada' || temCanceladas);

  const [dragId, setDragId] = useState(null);
  const [dragFromEtapa, setDragFromEtapa] = useState(null);
  const [dropTarget, setDropTarget] = useState(null);
  const [toast, setToast] = useState(null);

  const onDragStart = (e, d) => {
    if (!podeMover) return;
    setDragId(d.codigo);
    setDragFromEtapa(d.etapa);
    e.dataTransfer.effectAllowed = 'move';
    try { e.dataTransfer.setData('text/plain', String(d.codigo)); } catch {}
  };
  const onDragEnd = () => { setDragId(null); setDragFromEtapa(null); setDropTarget(null); };
  const onDragOver = (e, etapaKey) => {
    if (!dragId || etapaKey === dragFromEtapa) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setDropTarget(etapaKey);
  };
  const onDragLeave = (etapaKey) => {
    setDropTarget((cur) => (cur === etapaKey ? null : cur));
  };
  const onDrop = async (e, etapaKey) => {
    e.preventDefault();
    if (!dragId || etapaKey === dragFromEtapa) return;
    const id = dragId;
    const from = dragFromEtapa;
    setDragId(null); setDragFromEtapa(null); setDropTarget(null);
    try {
      await api.post(`/demandas/${id}/etapa`, { etapa: etapaKey });
      setToast({ tipo: 'ok', msg: `Movido para ${ETAPA_MAP[etapaKey].label}` });
      onChange?.();
    } catch (err) {
      const msg = err?.data?.error || err.message;
      const requerForce = err?.data?.requer_force;
      const ehAdmin = user?.perfil === 'admin';
      if (requerForce && ehAdmin && confirm(`${msg}\n\nForçar mesmo assim?`)) {
        try {
          await api.post(`/demandas/${id}/etapa`, { etapa: etapaKey, force: true });
          setToast({ tipo: 'ok', msg: `Movido (forçado) para ${ETAPA_MAP[etapaKey].label}` });
          onChange?.();
          return;
        } catch (e2) {
          setToast({ tipo: 'err', msg: e2.message });
          return;
        }
      }
      setToast({ tipo: 'err', msg });
    } finally {
      setTimeout(() => setToast(null), 3500);
    }
  };

  return (
    <>
      <div className="kanban">
        {colunas.map((c) => {
          const itens = demandas.filter((d) => d.etapa === c.key);
          const isTarget = dropTarget === c.key;
          return (
            <div
              className={`kanban-col ${isTarget ? 'drop-target' : ''}`}
              key={c.key}
              onDragOver={(e) => onDragOver(e, c.key)}
              onDragLeave={() => onDragLeave(c.key)}
              onDrop={(e) => onDrop(e, c.key)}
            >
              <div className="kanban-col-header">
                <div className="kanban-title">
                  <span className={`badge ${c.color}`} style={{ padding: '2px 8px', fontSize: 11 }}>
                    {c.label}
                  </span>
                </div>
                <span className="text-xs muted strong">{itens.length}</span>
              </div>
              <div className="kanban-col-body">
                {itens.length === 0 ? (
                  <div className="text-xs muted center" style={{ padding: '20px 0', textAlign: 'center' }}>
                    {isTarget ? 'Solte aqui' : 'Sem demandas'}
                  </div>
                ) : (
                  itens.map((d) => (
                    <div
                      key={d.id}
                      draggable={podeMover}
                      onDragStart={(e) => onDragStart(e, d)}
                      onDragEnd={onDragEnd}
                      className={dragId === d.codigo ? 'demand-card-wrap dragging' : 'demand-card-wrap'}
                      style={dragId === d.codigo ? { opacity: 0.4 } : undefined}
                    >
                      <DemandaCard demanda={d} />
                    </div>
                  ))
                )}
              </div>
            </div>
          );
        })}
      </div>

      {toast && (
        <div
          style={{
            position: 'fixed',
            bottom: 80,
            left: '50%',
            transform: 'translateX(-50%)',
            background: toast.tipo === 'ok' ? 'var(--c-success)' : 'var(--c-danger)',
            color: 'white',
            padding: '10px 20px',
            borderRadius: 10,
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            zIndex: 200,
            fontSize: 13,
            fontWeight: 500,
            maxWidth: 400,
          }}
        >
          {toast.msg}
        </div>
      )}
    </>
  );
}
